import React from "react";
import { Redirect } from "react-router-dom";

import Home from "../pages/dashboard/home";
import Reports from "../pages/dashboard/reports";
import Inbox from "../pages/inbox/inbox";
import UserEmailchat from "../pages/UserChat/UserEmailchat";
import Productqrcode from "../pages/qrcodemanagement/product-qrcode";
import Addnew from "../pages/qrcodemanagement/product-addnew";
import Productinformation from "../pages/qrcodemanagement/product-information";
import PersonalQRCode from "../pages/qrcodemanagement/personal-QRCode";
import CreateQRCode from "../pages/qrcodemanagement/personal-CreateQRCode";
import Editpersonalqrcode from "../pages/qrcodemanagement/personal-Editpersonalqrcode";
import Articleqrcode from "../pages/qrcodemanagement/article-qrcode";
import Addnewarticle from "../pages/qrcodemanagement/article-addnew";
import Articleinfopage from "../pages/qrcodemanagement/article-infopage";
import Rolemanagement from "../pages/setting/rolemanagement";
import Categories from "../pages/Categories/Categories";
import UserProfile from "../pages/UserProfile/UserProfile";
import Login1 from "../pages/LoginScreens/Login1";
import Logout from "../pages/LoginScreens/LogOut";
import Auth0response from "../pages/LoginScreens/Auth0response";
import ProductDetails from "../pages/productdetail/detail";
import ShorturlDetails from "../pages/productdetail/shorturl";
import PersonalQrCodedetails from "../pages/PersonalQrCodedetails/detail";
import PersonaShorturlDetails from "../pages/PersonalQrCodedetails/personalshorturl";
// import Splashscreen from '../pages/productdetail/splashscreen';
import Sttplan from "../pages/LoginScreens/Sttsignup/Sttplan";
import Freesignup from "../pages/LoginScreens/Sttsignup/Freesignup";
import Enterprisesign from "../pages/LoginScreens/Sttsignup/Enterprisesign";
import Sttplandetail from "../pages/LoginScreens/Sttsignup/Sttplandetail";
import Passwordmanagement from "../pages/setting/passwordmanagement";
import Invoice from "../pages/setting/invoice";
import Paymentandinvoices from "../pages/setting/paymentandinvoices";
import Yourpackagedetail from "../pages/setting/yourpackagedetail";
import Impression from "../pages/stt/impression";
import Contactandhelp from "../pages/stt/contactandhelp";
import Aboutus from "../pages/stt/aboutus";
import Privacypolicy from "../pages/stt/privacypolicy";
import Packages from "../pages/supperadmin/packages";
import Users from "../pages/supperadmin/users";
import Superdashboard from "../pages/supperadmin/superdashboard";
import CustomPackagepayment from "../pages/Payment/CustomPackagepayment";
import Pricingpage from "../pages/price/Pricingpage";
import Authcallback from "../pages/LoginScreens/Authcallback";
import Success from "../pages/success";
import Failer from "../pages/failer";


// import PersonalQRCode from '../pages/qrcodemanagement/Personal/personal-QRCodenew';
// import CreateQRCode from '../pages/qrcodemanagement/Personal/personal-CreateQRCodenew';
// import Editpersonalqrcode from '../pages/qrcodemanagement/Personal/personal-Editpersonalqrcodenew';

const routes = [
 
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/Login" />,
  },
  {
    path: "/home",
    exact: true,
    title: "Home",
    component: () => <Home />,
  },
  {
    path: "/customPackagepayment/:CustomMapID?/:CustomPID?",
    exact: true,
    title: "Payment",
    component: () => <CustomPackagepayment />,
  },
  
  {
    path: "/reports",
    exact: true,
    title: "Reports",
    component: () => <Reports />,
  },
  {
    path: "/inbox",
    exact: true,
    title: "Inbox",
    component: () => <Inbox />,
  },
  {
    path: "/UserEmailchat",
    exact: true,
    title: "User Email",
    component: () => <UserEmailchat />,
  },
  // {

 

  {
    // path: "/qrcodemanagement/article-qrcode",
    path: "/article-qrcode",
    exact: true,
    title: "Articleqrcode",
    component: () => <Articleqrcode />,
  },
  {
    path: "/article-addnew",
    exact: true,
    title: "Addnewarticle",
    component: () => <Addnewarticle />,
  },
  {
    path: "/article-infopage",
    exact: true,
    title: "Articleinfopage",
    component: () => <Articleinfopage />,
  },

  {
    // path: "/qrcodemanagement/personal-QRCode",
    path: "/personal-QRCode",
    exact: true,
    title: "PersonalQRCode",
    component: () => <PersonalQRCode />,
  },

  
  {
    path: "/personal-CreateQRCode",
    exact: true,
    title: "CreateQRCode",
    component: () => <CreateQRCode />,
  },
 
  {
    path: "/personal-Editpersonalqrcode",
    exact: true,
    title: "Editpersonalqrcode",
    component: () => <Editpersonalqrcode />,
  },
 
  {
    // path: "/qrcodemanagement/product-qrcode",
    path: "/product-qrcode",
    exact: true,
    title: "Productqrcode",
    component: () => <Productqrcode />,
  },
  {
    path: "/product-addnew",
    exact: true,
    title: "Addnew",
    component: () => <Addnew />,
  },
  {
    path: "/product-information",
    exact: true,
    title: "Productinformation",
    component: () => <Productinformation />,
  },
  {
    path: "/setting/rolemanagement",
    exact: true,
    title: "Rolemanagement",
    component: () => <Rolemanagement />,
  },
  {
    path: "/passwordmanagement",
    exact: true,
    title: "Password management",
    component: () => <Passwordmanagement />,
  },

  {
    path: "/paymentandinvoices",
    exact: true,
    title: "Paymentandinvoices",
    component: () => <Paymentandinvoices />,
  },
  {
    path: "/yourpackagedetail",
    exact: true,
    title: "Yourpackagedetail",
    component: () => <Yourpackagedetail />,
  },
  {
    path: "/setting/invoice",
    exact: true,
    title: "Invoice",
    component: () => <Invoice />,
  },

  {
    path: "/contactandhelp",
    exact: true,
    title: "Contactandhelp",
    component: () => <Contactandhelp />,
  },
  {
    path: "/privacypolicy",
    exact: true,
    title: "Privacypolicy",
    component: () => <Privacypolicy />,
  },
  {
    path: "/packages",
    exact: true,
    title: "Packages",
    component: () => <Packages />,
  },
  {
    path: "/users",
    exact: true,
    title: "Users",
    component: () => <Users />,
  },
  {
    path: "/superdashboard",
    exact: true,
    title: "Superdashboard",
    component: () => <Superdashboard />,
  },
  {
    path: "/aboutus",
    exact: true,
    title: "Aboutus",
    component: () => <Aboutus />,
  },

  {
    path: "/stt/impression",
    exact: true,
    title: "Impression",
    component: () => <Impression />,
  },
  {
    path: "/Categories",
    exact: true,
    title: "Categories",
    component: () => <Categories />,
  },
  {
    path: "/UserProfile",
    exact: true,
    title: "UserProfile",
    component: () => <UserProfile />,
  },

  {
    path: "/Login",
    exact: true,
    title: "Login",
    component: () => <Login1 />,
  },
  {
    path: "/Success",
    exact: true,
    title: "Success",
    component: () => <Success />,
  },
  {
    path: "/Failer",
    exact: true,
    title: "Failer",
    component: () => <Failer />,
  },
  {
    path: "/Logout",
    exact: true,
    title: "Logout",
    component: () => <Logout />,
  },
  {
    path: "/Auth0response",
    exact: true,
    title: "Auth0response",
    component: () => <Auth0response />,
  },

  {
    path: "/Sttplan",
    exact: true,
    title: "Sttplan",
    component: () => <Sttplan />,
  },
  {
    path: "/Enterprisesign",
    exact: true,
    title: "Enterprisesign",
    component: () => <Enterprisesign />,
  },
  {
    path: "/Freesignup",
    exact: true,
    title: "Freesignup",
    component: () => <Freesignup />,
  },
  {
    path: "/Sttplandetail",
    exact: true,
    title: "Sttplandetail",
    component: () => <Sttplandetail />,
  },
  {
    path: "/productdetails/:mapId?/:render?",
    exact: true,
    title: "productdetails1",
    component: () => <ProductDetails />,
  },
  {
    path: "/Pricingpage",
    exact: true,
    title: "Pricingpage",
    component: () => <Pricingpage />,
  },
  {
    path: "/Authcallback",
    exact: true,
    title: "Authcallback",
    component: () => <Authcallback />,
  },
  {
    path: "/PersonalQrCodedetails/:mapId?/:render?",
    exact: true,
    title: "PersonalQrCodedetails1",
    component: () => <PersonalQrCodedetails />,
  },
  {
    path: "/:id",
    exact: true,
    title: "Shorturl",
    component: () => <ShorturlDetails />,
  },


  // {
  //   path: "/a/:sid",
  //   exact: true,
  //   title: "Shorturl",
  //   component: () => <ShorturlDetails/>,
  // },
  // {
  //   path: "/article/:mapId?",
  //   exact: true,
  //   title: "Shorturl",
  //   component: () => <ShorturlDetails/>,
  // },
  // {
  //   path: "/personal/:mapId?",
  //   exact: true,
  //   title: "Shorturl",
  //   component: () => <PersonaShorturlDetails />,
  // },
  
];

export default routes;
